<script setup lang="ts">
import { Box } from 'lucide-vue-next'

const props = withDefaults(defineProps<{
  title: string
  hint?: string
  colspan?: number | string
}>(), { hint: undefined, colspan: undefined })
</script>

<template>
  <tr>
    <td :colspan="props.colspan" class="px-6 py-12 text-center text-sm text-gray-500 dark:text-gray-400">
      <div class="flex flex-col items-center justify-center">
        <div class="mb-3 flex size-12 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
          <Box class="size-6 text-gray-800 dark:text-white/90" />
        </div>
        <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">
          {{ props.title }}
        </h4>
        <p v-if="props.hint" class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {{ props.hint }}
        </p>
      </div>
    </td>
  </tr>
</template>
